import { useCallback, useState, useEffect, useRef } from 'react';
import axios from "../../../common/axios";

export function useUpdateTestResults({ testResult, testRef, onError }) {
    const [isUpdating, setUpdating] = useState(false);
    const isUpdatingRef = useRef(isUpdating);

    useEffect(() => {
        isUpdatingRef.current = isUpdating;
    }, [isUpdating]);

    const updateTestResults = ({questionId, submitAnswers = false, onComplete}) => {
        if (isUpdatingRef.current || !testRef?.current || !testResult) {
            return;
        }

        const questionForm = $('.js-testQuestionPage', testRef.current);
        const formData = questionForm.serializeArray();
        formData.push({ name: 'testId', value: testResult.testId });
        formData.push({ name: 'testAssignmentId', value: testResult.testAssignmentId });
        formData.push({ name: 'submitAnswers', value: submitAnswers });
        if(questionId) {
            formData.push({name: 'currentQuestionId', value: questionId});
        }

        const params = new URLSearchParams();
        formData.forEach((field) => params.append(field.name, field.value));

        $('.js-testContent', testRef.current).prop('disabled', true);
        setUpdating(true);
        axios
            .post('/web/ui/test/testQuestion/updateResults', params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            })
            .then((response) => {
                onComplete?.(response.data);
            })
            .catch((error) => {
                console.error(error);
                onError?.('There was an error updating your results. Please try again.');
            })
            .finally(() => {
                window.onbeforeunload = null;
                if (testRef?.current) {
                    $('.js-testContent', testRef.current).prop('disabled', false);
                }
                setUpdating(false);
            });
    };

    return {
        isUpdating,
        updateTestResults,
    };
}

export function useCloseTest({ testResult, testRef, loadShortcutByUrl, onError }) {
    const [isClosing, setIsClosing] = useState(false);


    const closeTest = useCallback(() => {
        if (!testResult) {
            return;
        }

        setIsClosing(true);
        axios
            .get('/controlCentre/closeTestAssignment.action', {
                params: { testAssignmentId: testResult.testAssignmentId },
            })
            .then(() => {
                loadShortcutByUrl('/web/ui/view/test/studentTestAssignments');
            })
            .catch((error) => {
                console.error(error);
                onError?.('There was an error updating your results. Please try again.');
            })
            .finally(() => {
                window.onbeforeunload = null;
                if (testRef?.current) {
                    $('.js-testContent', testRef.current).prop('disabled', true);
                }
                setIsClosing(false);
            });
    }, [testResult, testRef, loadShortcutByUrl, onError]);

    return {
        isClosing,
        closeTest,
    };
}

export function useSubmitTest({
                                  testResult,
                                  setTestAssignmentResult,
                                  setSubmitted,
                                  loadShortcutByUrl,
                                  onError,
                                  displayToastMessage,
                              }) {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const submitTest = useCallback(
        (onComplete) => {
            if (testResult === undefined || testResult.testAssignmentId === undefined) {
                return;
            }

            setIsSubmitting(true);
            const params = new URLSearchParams();
            params.append('testAssignmentId', testResult.testAssignmentId);
            axios
                .post('/controlCentre/submitTest.action', params, {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                })
                .then((response) => {
                    if (response.data) {
                        setTestAssignmentResult?.(response.data.testAssignmentResult);
                        setSubmitted(response.data.success);
                        if (onComplete) {
                            onComplete(response.data.success);
                        } else {
                            if (response.data.success) {
                                displayToastMessage?.('Test submitted', 'Your test has been submitted.', 'success');
                                loadShortcutByUrl('/web/ui/view/test/studentTestAssignments');
                            } else {
                                onError?.('There was an error submitting your test. Please try again.');
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.error('Submission error:', error);
                    onError?.('There was an error submitting your test. Please try again.');
                })
                .finally(() => {
                    window.onbeforeunload = null;
                    setIsSubmitting(false);
                });
        },
        [testResult, setTestAssignmentResult, loadShortcutByUrl, onError, displayToastMessage]
    );

    return {
        isSubmitting,
        submitTest,
    };
}
